import useTranslation from '@app/hooks/use-translation';

import { FilterOptionsListAndRules } from './blocks/appeal-filter/types';

export const useGetAppealData = () => {
  const { t } = useTranslation('pages.qmAppeal');
  const appealFilterKeys: FilterOptionsListAndRules[] = [
    {
      index: 'dt_create',
      title: t('filter.dt_create'),
      conditions: 'restOfEqual',
      singleNestedField: true,
      field_type: 'datepicker',
    },
    {
      index: 'dt_sent',
      title: t('filter.dt_sent'),
      conditions: 'restOfEqual',
      singleNestedField: true,
      field_type: 'datepicker',
    },
    {
      index: 'dt_processing',
      title: t('filter.dt_processing'),
      conditions: 'restOfEqual',
      singleNestedField: true,
      field_type: 'datepicker',
    },
    { index: 'operator', title: t('filter.operator'), conditions: 'equal' },
    { index: 'сontroller', title: t('filter.сontroller'), conditions: 'equal' },
    { index: 'inspect', title: t('filter.inspect'), conditions: 'equal' },
    { index: 'mfs', title: t('filter.mfs'), conditions: 'equal' },
    {
      index: 'status',
      title: t('filter.status'),
      conditions: 'equal',
      field_type: 'select',
      select: {
        options: [
          { title: t('filter.statuses.CREATED'), value: 'CREATED' },
          { title: t('filter.statuses.SENT'), value: 'SENT' },
          { title: t('filter.statuses.CLOSED'), value: 'CLOSED' },
          { title: t('filter.statuses.IN_WORK'), value: 'IN_WORK' },
          { title: t('filter.statuses.DECLINED'), value: 'DECLINED' },
          { title: t('filter.statuses.ACCEPTED'), value: 'ACCEPTED' },
        ],
      },
    },
    {
      index: 'resolution',
      title: t('filter.resolution'),
      field_type: 'select',
      conditions: 'equal',
      select: {
        options: [
          { title: t('filter.resolutions.OPERATOR_ERROR'), value: 'OPERATOR_ERROR' },
          { title: t('filter.resolutions.CONTROLLER_ERROR'), value: 'CONTROLLER_ERROR' },
          { title: t('filter.resolutions.NO_ERROR'), value: 'NO_ERROR' },
        ],
      },
    },
  ];
  return { appealFilterKeys };
};
